import { Styles } from "@/shared/coralreef";

import { padding, px, rem } from "csx";
import { Horizontal } from "gls/lib";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SitesContext } from "@/shared/context/Sites";
import { style } from "typestyle";
import { useContextSelector } from "use-context-selector";

interface SiteCagePickerButtonProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const SiteCagePickerButton: FC<SiteCagePickerButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();
  const { sites, selectedSites, selectedCages } = useContextSelector(
    SitesContext,
    (sites) => ({
      selectedSites: sites.selectedSites,
      selectedCages: (sites.selectedCages?.[sites.selectedSites[0]] || [])
        .length,
      sites: sites.sites || [],
    }),
  );

  const selectedSitesText = useMemo(() => {
    let text = t("No sites selected");

    if (selectedSites.length === 1) {
      const site = sites.find((s) => s.id === selectedSites[0]);
      text = `${
        selectedSites.length === 1 &&
        site?.cages.length !== selectedCages &&
        selectedCages !== 0
          ? `(${selectedCages || site?.cages.length}/${site?.cages.length}) `
          : ""
      }${site?.name || ""}`;
    } else if (selectedSites.length > 1) {
      text = t("Multiple sites");
    }

    return text;
  }, [selectedSites, selectedCages, sites, t]);

  return (
    <Horizontal
      sizing="stretch"
      spacing={0}
      minWidth={rem(10)}
      className={container}
      style={{
        color:
          selectedSites.length > 0
            ? Styles.Colours.textLight
            : Styles.Colours.textDark,
      }}
      verticalAlign="center"
      onClick={onClick}
    >
      <Horizontal size={2} verticalAlign="center">
        {!sites ? t("Loading sites") : selectedSitesText}
      </Horizontal>
    </Horizontal>
  );
};

const container = style({
  padding: padding(0, px(13)),
  backgroundColor: Styles.Colours.darkBlue,
  border: `1px solid ${Styles.Colours.blue}`,
  borderRadius: px(5),
  borderBottomWidth: px(1),
  height: px(36),
  cursor: "pointer",
});
